import { useMemo } from "react"
import { isPendingApproval } from "../lib/approval"
import { compareThoughtsByDate } from "../lib/format"
import type { Thought } from "./types"

export function useHasPendingApproval(
	thoughts: Thought[] | undefined,
): boolean {
	return useMemo(() => thoughts?.some(isPendingApproval) ?? false, [thoughts])
}

export function useOldestPendingThought(
	thoughts: Thought[] | undefined,
): Thought | undefined {
	return useMemo(() => {
		const pending = thoughts?.filter(isPendingApproval)
		if (!pending || pending.length === 0) return undefined
		return pending.reduce((oldest, thought) => {
			if (compareThoughtsByDate(thought, oldest) < 0) return thought
			return oldest
		})
	}, [thoughts])
}
